import React, { useEffect, useLayoutEffect, useRef } from 'react';

import ApexCharts from 'apexcharts';
import Chart from 'react-apexcharts';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

import { decimalUpTo } from 'Helpers/currencyFormat';

import Button from 'CommonComponents/Button';

let colorPalette = ['#000061', '#4300B8', '#640AFF', '#27B6FF', '#D8C2FF'];

const lineOption = {
    chart: {
        fontFamily: 'var(--font-sans)',
        id: 'total-headcount',
        type: 'bar',
        height: 380,
        width: '100%',
        stacked: true,
        toolbar: {
            tools: {
                download: false,
                pan: false,
                reset: false,
                selection: false,
                zoom: false,
            },
        },
    },
    tooltip: {
        y: {},
    },

    colors: colorPalette,
    series: [
        {
            name: [],
            data: [],
            type: 'column',
        },
        {
            name: [],
            data: [],
            type: 'column',
        },
    ],
    labels: [],
    xaxis: {
        labels: {
            show: true,
        },
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
    },
    yaxis: {
        opposite: true,
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            style: {
                colors: '#78909c',
            },
            formatter: function (val) {
                return decimalUpTo(val.toFixed(0));
            },
        },
    },
    legend: {
        show: false,
    },
    title: {
        text: 'Headcount',
        align: 'left',
        style: {
            fontSize: '18px',
            color: '#000061',
        },
    },
};

const TotalheadcountChart = ({ data, action }) => {
    const firstUpdate = useRef(true);

    const changeDate = () => {
        setTimeout(() => {
            window.DateUtils.monthYearFieldInit($('#headcountStart'));
            window.DateUtils.monthYearFieldInit($('#headcountEnd'));
        }, 250);
    };

    const changeData = (times = Infinity) => {
        if (data !== undefined && !data.error) {
            const labels = [];
            const series = [];
            data.forEach((e, index) => {
                if (series[index] === undefined) series[index] = {};
                series[index].type = 'column';
                if (series[index].name === undefined) series[index].name = [];
                series[index].name = e.name;
                e.totals.forEach((j, i) => {
                    if (i < times) {
                        if (series[index].data === undefined) series[index].data = [];
                        series[index].data.push(j.cumulative);
                        labels.push(j.date);
                    }
                });
            });
            setTimeout(() => {
                ApexCharts.exec('total-headcount', 'updateOptions', {
                    labels: labels,
                });

                ApexCharts.exec('total-headcount', 'updateSeries', series);
            }, 0.1);
        }
    };
    useEffect(() => {
        changeData(12);
    }, []);
    useLayoutEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        changeData();
    }, [data]);
    return (
        <>
            <Tabs>
                <TabList>
                    <Tab onClick={(e) => changeData()}>Chart</Tab>
                    <Tab onClick={(_) => changeDate()}>Filter</Tab>
                </TabList>

                <TabPanel>{data !== undefined && !data.error && <Chart options={lineOption} series={lineOption.series} type="line" height={200} />}</TabPanel>
                <TabPanel>
                    {/*<DateRangePicker onOk={value => action(value)} defaultOpen={true} />*/}
                    <div className="chart_style row">
                        <div className="chart_style col-5">
                            <div className="chart_style col">
                                <div className="chart_style row no-gutters align-items-center">
                                    <div className="chart_style col-auto px-2">
                                        <label htmlFor="headcountStart">From: </label>
                                    </div>
                                    <div className="chart_style col px-2">
                                        <input
                                            type="text"
                                            placeholder="Select date"
                                            className="chart_style form-control month-year-input"
                                            id="headcountStart"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="chart_style col-5">
                            <div className="chart_style row no-gutters align-items-center">
                                <div className="chart_style col-auto px-2">
                                    <label htmlFor="headcountEnd">To: </label>
                                </div>
                                <div className="chart_style col px-2">
                                    <input type="text" placeholder="Select date" className="chart_style form-control month-year-input" id="headcountEnd" />
                                </div>
                            </div>
                        </div>
                        <div className="chart_style col-2 pl-3">
                            <Button
                                variant="primary"
                                onClick={() => action($('#headcountStart').val(), $('#headcountEnd').val(), 'headcount')}
                                className="chart_style"
                            >
                                Filter
                            </Button>
                        </div>
                    </div>
                </TabPanel>
            </Tabs>
        </>
    );
};

export default React.memo(TotalheadcountChart);
